var hamburger = document.querySelector('.hamburger');
var menu = document.querySelector('.navigation');
var header = document.querySelector('.header');
var body = document.body;

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
}

if (hamburger) {
    hamburger.addEventListener('click', toggleMenu);
}

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        var clickableArrow = document.createElement('span');
        clickableArrow.setAttribute('class', 'icon-submenu')

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu:not(.megamenu-column)').classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.append(clickableArrow);
    }

    if (element.querySelector('.megamenu')) {
        element.classList.add('category');
    }
});
